<div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
  <!-- Header Section -->
  <div class="text-center mb-5">
    <img src="assets/brand/{{
        layoutService.colorScheme() === 'light'
          ? 'logo-light'
          : 'logo-dark'
      }}.png" alt="Sequal App Logo" height="50" class="mb-3" />
    <div class="text-900 text-3xl font-medium mb-3">
      Set New Password
    </div>
    <span class="text-600 font-medium line-height-3">Enter your new password below</span>
  </div>

  <!-- Reset Password Form -->
  <form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
    <!-- Password Field -->
    <div class="mb-3">
      <label for="password" class="block text-900 font-medium mb-2">New Password</label>
      <p-password id="password" placeholder="Enter new password" [feedback]="false" [toggleMask]="true"
        formControlName="password" styleClass="w-full" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}">
      </p-password>
      @if (passwordErrorText(); as passwordErr) {
        <small class="p-error">
          {{ passwordErr }}
        </small>
      }
    </div>

    <!-- Confirm Password Field -->
    <div class="mb-3">
      <label for="confirmPassword" class="block text-900 font-medium mb-2">Confirm Password</label>
      <p-password id="confirmPassword" placeholder="Confirm new password" [feedback]="false" [toggleMask]="true"
        formControlName="confirmPassword" styleClass="w-full" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}">
      </p-password>
      @if (confirmPasswordErrorText(); as confirmErr) {
        <small class="p-error">
          {{ confirmErr }}
        </small>
      }
    </div>

    <!-- Captcha -->
    @if (isCaptchaRequired()) {
      <div class="mb-3 sm:mb-4">
        <app-captcha />
      </div>
    }

    <!-- Submit Button -->
    <button pButton pRipple label="Reset Password" icon="pi pi-key" class="w-full"
    [disabled]="newPasswordForm.invalid || isSubmitting()" [loading]="isSubmitting()"></button>

    <!-- Success Message -->
    @if (resetSuccess()) {
      <p class="success-message mt-3">
        Password reset successful! Redirecting to login...
      </p>
    }

    <!-- Back to Login Link -->
  </form>
  <div class="text-center mt-4">
    <span class="text-600 font-medium line-height-3">Link expired?</span>
    <a (click)="navigateToRequestReset()" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Request a new one</a>
  </div>
  <div class="text-center mt-2">
    <span class="text-600 font-medium line-height-3">Remember your password?</span>
    <a (click)="navigateToLogin()" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Sign in</a>
  </div>
</div>